import { TableEventType } from './enums/action-type.enum';

export class TableEvent {
  payload?: unknown;
  eventType: TableEventType;

  constructor(data: TableEvent) {
    Object.assign(this, data);
  }

  static create(data: TableEvent) {
    return new TableEvent(data);
  }
}